import { ICustomList, TPermissionInfo } from '../AddToList/shared';

interface IIsUserCuratorForList {
  customList?: ICustomList;
  userId?: string;
}

const isUserLastCuratorForList = ({
  customList,
  userId,
}: IIsUserCuratorForList): boolean => {
  if (!customList?.permissions || !userId) {
    return false;
  }

  return customList.permissions
    .filter((permission: TPermissionInfo): boolean =>
      permission.roles.includes('admin')
    )
    .every(
      (permission: TPermissionInfo): boolean => permission.userId === userId
    );
};

export default isUserLastCuratorForList;
